import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const SubdistrictFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
        filterComponentState,
        setSubdistrictFilter,
    } = useFilterContext();

    const { selectedSubdistricts, isSubdistrictFilterActive } = filterUIState;
    const { subdistrictOptions } = filterComponentState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const handleChange = (subdistrict) => {
        const newSelected = selectedSubdistricts.includes(subdistrict)
            ? selectedSubdistricts.filter(item => item !== subdistrict)
            : [...selectedSubdistricts, subdistrict];
        updateUI({ selectedSubdistricts: newSelected });
    };

    const handleSelectAll = (selectAll) => {
        updateUI({
            selectedSubdistricts: selectAll ? [...subdistrictOptions] : [],
        });
    };

    const apply = () => {
        if (selectedSubdistricts.length === 0) {
            updateUI({ isSubdistrictFilterActive: true });
        } else {
            const isAllSelected = selectedSubdistricts.length === subdistrictOptions.length;
            updateUI({ isSubdistrictFilterActive: !isAllSelected && selectedSubdistricts.length > 0 });
        }
        setSubdistrictFilter(selectedSubdistricts);
        onFilterChange(selectedSubdistricts);
        onClose();
    };

    const reset = () => {
        const currentOptions = [...subdistrictOptions];
        updateUI({ selectedSubdistricts: currentOptions, isSubdistrictFilterActive: false });
        onFilterChange(null);
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="동필터"
                activeLabel="동필터적용"
                isActive={isSubdistrictFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="동 필터 설정" onClose={onClose} className="right-0">
                    <div className="flex items-center justify-between mb-2 text-sm">
                        <button
                            onClick={() => handleSelectAll(true)}
                            className="px-2 py-1 text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 rounded"
                        >
                            전체 선택
                        </button>
                        <button
                            onClick={() => handleSelectAll(false)}
                            className="px-2 py-1 text-xs bg-gray-50 hover:bg-gray-100 text-gray-700 rounded"
                        >
                            전체 해제
                        </button>
                    </div>
                    <div className="max-h-40 overflow-y-auto mb-3 border border-gray-100 rounded p-1">
                        {subdistrictOptions.map((subdistrict) => (
                            <div key={subdistrict} className="flex items-center mb-1">
                                <input
                                    type="checkbox"
                                    id={`subdistrict-${subdistrict}`}
                                    checked={selectedSubdistricts.includes(subdistrict)}
                                    onChange={() => handleChange(subdistrict)}
                                    className="mr-2"
                                />
                                <label htmlFor={`subdistrict-${subdistrict}`} className="text-sm">
                                    {subdistrict}
                                </label>
                            </div>
                        ))}
                    </div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default SubdistrictFilter;
